import * as React from "react";
import { forwardRef } from "react";
const SvgViewAttributeTableClearSelection = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15.8333 5.3415L14.6583 4.1665L10 8.82484L5.34167 4.1665L4.16667 5.3415L8.82501 9.99984L4.16667 14.6582L5.34167 15.8332L10 11.1748L14.6583 15.8332L15.8333 14.6582L11.175 9.99984L15.8333 5.3415Z", fill: "black", fillOpacity: 0.54 }));
const ForwardRef = forwardRef(SvgViewAttributeTableClearSelection);
export default ForwardRef;
